import * as React from "react";
import { useEffect, useState } from "react";
import { Dialog, DialogContent, IconButton, Link, styled } from "@mui/material";
import { ClinicDialog } from "ask/src/components/clinic/elements/clinicDialog";
import { ReactComponent as AlertHexIcon } from "../assets/alertHexIcon.svg";
// import { FormInput } from "../layout/formInput";
// import { ClinicSmallButton } from "../clinic/clinicActionButton";
import { useTranslateByGender } from "fe-common/locale/useTranslateByGender";
import { useClinicState } from "ask/src/clinic/clinicStateContext";
import { PatientCardAnswerPrompt } from "./patientCardAnswerPrompt";
import { ClinicColors } from "../styles/clinicTheme";
import CloseIcon from "@mui/icons-material/Close";
import { QuestionTypes } from "dialogue/src/types/types";
// import { copyToClipboard } from "fe-common/utils/copyToClipboard";

//region [[ Styles ]]
const AppointmentSummaryView = styled("div")({
  width: 600,
  paddingTop: 20,
  display: "flex",
  flexDirection: "column",
  gap: 8,
  height: "100%",
  overflow: "hidden",
});

const AppointmentSummaryDisclaimer = styled("div")({
  display: "flex",
  alignItems: "start",
  background: ClinicColors.lightBackground,
  fontSize: 13,
  padding: 8,
  borderRadius: 4,
  gap: 8,
  direction: "ltr",
  width: 600,
  "& a": {
    cursor: "pointer",
  },
  "& svg": {
    minWidth: 20,
    height: 20,
  },
});

const CloseMoreButton = styled(IconButton)({
  position: "absolute",
  top: 2,
  right: 2,
  zIndex: 400,
  "&:dir(rtl)": {
    right: "unset",
    left: 2,
  },
});

const MoreContent = styled(DialogContent)({
  marginTop: 10,
  padding: 20,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface AppointmentSummaryProps {
  open: boolean;
  onClose: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AppointmentSummary = ({
  open,
  onClose,
}: AppointmentSummaryProps) => {
  const [prompt, setPrompt] = useState("");
  //const [submittedPrompt, setSubmittedPrompt] = useState("");
  //const [hidePrompt, setHidePrompt] = useState(true);
  const [showMore, setShowMore] = useState(false);

  const [{ clinicConfig, rtlDisplay }] = useClinicState();

  useEffect(() => {
    if (clinicConfig?.standalone) {
      setPrompt(clinicConfig.standalone.appointmentSummaryPrompt);
    }
  }, [clinicConfig]);

  // const handleGenerate = async () => {
  //   setHidePrompt(true);
  //   setSubmittedPrompt(prompt);
  // };

  return (
    <>
      <ClinicDialog
        onClose={onClose}
        closeButton={true}
        open={open}
        maxWidth={"lg"}
        rtlDisplay={rtlDisplay}
        scroll="paper"
        PaperProps={{
          style: { height: "100%" },
        }}
      >
        <DialogContent className={"dialog-content"}>
          <AppointmentSummaryDisclaimer>
            <AlertHexIcon />
            <div>
              Summary was generated with the support of GenAI and may include
              certain inaccuracies{" "}
              <Link onClick={() => setShowMore(true)}>(Read more)</Link>. Please
              review before taking further steps
            </div>
          </AppointmentSummaryDisclaimer>
          <AppointmentSummaryView>
            {/*<AppointmentPromptForm className={hidePrompt ? "closed" : ""}>*/}
            {/*  <strong>{translate("APPOINTMENT_SUMMARY")}</strong>*/}
            {/*  <FormInput*/}
            {/*    value={prompt}*/}
            {/*    disabled={loading}*/}
            {/*    multiline*/}
            {/*    onChange={(e) => {*/}
            {/*      setPrompt(e.target.value);*/}
            {/*    }}*/}
            {/*  />*/}
            {/*  <ButtonsView>*/}
            {/*    <ClinicSmallButton*/}
            {/*      onClick={handleGenerate}*/}
            {/*      label={translate("SEND")}*/}
            {/*      disabled={!prompt || loading}*/}
            {/*    />*/}
            {/*  </ButtonsView>*/}
            {/*</AppointmentPromptForm>*/}
            {prompt && (
              <PatientCardAnswerPrompt
                questionType={QuestionTypes.Summary}
                prompt={prompt}
              />
            )}
          </AppointmentSummaryView>
        </DialogContent>
      </ClinicDialog>
      {showMore && (
        <Dialog open={true} scroll="paper" onClose={onClose} maxWidth={"md"}>
          <CloseMoreButton onClick={() => setShowMore(false)} size={"small"}>
            <CloseIcon />
          </CloseMoreButton>
          <MoreContent>
            Generative AI is a type of artificial intelligence that creates new
            content such as text, images, audio, and video by learning patterns
            from existing data. Unlike traditional AI, which focuses on
            analyzing data, generative AI models can produce realistic and
            creative outputs. This technology is used in various applications,
            including content creation, design, entertainment, and personalized
            marketing, enabling innovative solutions and more natural
            human-computer interactions.
            <br />
            <br />
            The following summary has been generated using artificial
            intelligence (GenAI). While we strive for accuracy, the content may
            not fully capture all nuances and details of the original intake
            process. The summary does not replace the professional judgment of a
            medical expert and we encourage you to carefully review the summary
            and any additional information based on the summary before making
            any decisions or taking further steps based on it. The summary and
            related information are provided to support medical professionals
            and not to replace their judgment.
          </MoreContent>
        </Dialog>
      )}
    </>
  );
};
